interface ITotalOrderItemProps {
  href?: string;
  isLink?: boolean;
  isNegative?: boolean;
  alignStart?: boolean;
  title: string;
  value?: string | number;
  className?: string;
  titleClass?: string;
  valueClass?: string;
}

const TotalOrderItem = ({
  href,
  isLink,
  isNegative,
  alignStart,
  title,
  value,
  className,
  titleClass = 'text-sm',
  valueClass = 'text-sm',
  ...props
}: ITotalOrderItemProps) => (
  <div
    className={[
      `d-flex space-between ${alignStart ? 'align-start' : 'align-center'}`,
      className,
    ].join(' ')}
    {...props}
  >
    <div className={`${titleClass}`}>{title}</div>
    {isLink ? (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className={`${valueClass} text-nowrap`}
      >{`${isNegative ? '-' : ''}${value}`}</a>
    ) : (
      <div
        className={`${valueClass} text-nowrap`}
      >{`${isNegative ? '-' : ''}${value || ''}`}</div>
    )}
  </div>
);

export default TotalOrderItem;
